import Vue from 'vue'
import App from './App'
import router from './router'
import VisionUI from 'yotta-vue-components/vision-ui-plugin.js'
import http from '@/http/index.js'
import ElementUI from 'element-ui'
import '@/css/element-variables.scss'
import store from '@/store/index.js'
import moment from '@/mixin/moment.js'
import filtersNum from '@/filters/filtersNum.js'
import cookie from 'js-cookie'
import echarts from 'echarts/lib/echarts'
import MyPlugin from '@/common/print.js'
import 'echarts/lib/chart/line'
// import 'echarts/lib/chart/bar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'

import 'echarts/lib/component/title'

import htmlToPdf from '@/common/htmlToPdf.js'
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(htmlToPdf)

Vue.prototype.$echarts = echarts
Vue.prototype.$cookie = cookie
Vue.use(filtersNum);
Vue.use(ElementUI)
Vue.use(VisionUI)
Vue.use(MyPlugin)
Vue.prototype.$http = http
Vue.mixin(moment)
Vue.config.productionTip = false
Vue.prototype.$resourceUrl = 'http://vision-resource.yottasystem.com'
Vue.prototype.$resourceLegacyUrl = 'http://vision-resource-legacy.yottasystem.com'
Vue.prototype.$trainUrl = 'http://vision-train.yottasystem.com'

// if (window.location.host.indexOf('mumuqing.net') > -1) {
  console.log('is mumuqing')
  Vue.prototype.$resourceUrl = 'https://vision-resource.mumuqing.net'
  Vue.prototype.$resourceLegacyUrl = 'https://vision-resource-legacy.mumuqing.net'
  Vue.prototype.$trainUrl = 'https://vision-train.mumuqing.net'
// }

// import VueElectron from 'vue-electron'
// Vue.use(VueElectron)

/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js